import _ from "underscore";
const ReactHypernovaHelper = {
  applyToServersideComponents(callbackFn) {
    const hypernovaDataAttribute = "data-hypernova-react-class";

    _.each(document.querySelectorAll(`div[${hypernovaDataAttribute}]`), function (node) {
      const reactClassname = node.getAttribute(hypernovaDataAttribute);
      const componentClass = window[reactClassname];

      if (!componentClass) {
        window.console?.warn("Component not found: " + reactClassname);
        return;
      }

      callbackFn(node, componentClass);
    });
  },
};

export default ReactHypernovaHelper;

export const { applyToServersideComponents } = ReactHypernovaHelper;
